import { billingDaysChoices, getInvalidBillingDays } from "@smartrr/shared/utils/dateUtils";
import { useMemo } from "react";

import { useOrganization } from "../../utils";

export const useDisabledDatesByBillingDays = (day: Date) => {
  const organization = useOrganization();
  const dayVals = useMemo(() => billingDaysChoices.map(day => day.value), []);
  const selectedBillingDays = organization?.setup?.billingDays ?? dayVals;

  return useMemo(() => getInvalidBillingDays(selectedBillingDays, day), [selectedBillingDays, day]);
};
